import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useSelections } from "../../context/Selections";
import DashboardDesktop from "./DashboardDesktop";
import DashboardDesktopYTD from "./DashboardDesktopYTD";
import DashboardMobile from "./DashboardMobile";

function Dashboard({ app, config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });
  const [vAlternaPeriodo, setVAlternaPeriodo] = useState(0);

  const { selections } = useSelections();
  useEffect(() => {
    if (app) {
      app.variable.getContent("vAlternaPeriodo", (reply) => {
        const data = reply.qContent.qString;
        setVAlternaPeriodo(data);
      });
    }
  }, [selections]);
  return isMobile ? (
    <DashboardMobile app={app} config={config} />
  ) : (
    <>
      {vAlternaPeriodo == 1 ? (
        <DashboardDesktop app={app} config={config} />
      ) : (
        <DashboardDesktopYTD app={app} config={config} />
      )}
    </>
  );
}

Dashboard.defaultProps = {
  app: null,
  config: {},
};

Dashboard.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Dashboard;
